import TWEEN from '@tweenjs/tween.js';
import * as THREE from 'three';
import { CSS2DRenderer,CSS2DObject} from "three/examples/jsm/renderers/CSS2DRenderer.js";
  
const TweenAnim = (mesh,objectData) => {

   const time = 2000;
   let _frameCount = 1;

   const _startPos = mesh.position.clone();
   const _startRot = mesh.rotation.clone();

   const objectScale= mesh.scale.clone();
   const _startScale = new THREE.Vector3();
   _startScale.set(objectScale.x, objectScale.y, objectScale.z);

    let _newPos , _newRot , _newScale ;


    if(objectData.isReverseAnimation)
    {
        _frameCount = objectData.objectsTranforms.length - 1;

     let {x:posX,y:posY,z:posZ} = objectData?.objectsTranforms[_frameCount]?.objectPostion;
     let {x:rotX,y:rotY,z:rotZ} = objectData?.objectsTranforms[_frameCount]?.objectPostion;
     let {x:scaleX,y:scaleY,z:scaleZ} = objectData?.objectsTranforms[_frameCount]?.objectScale;


        mesh.position.set(posX, posY, posZ);
        mesh.rotation.set(rotX,  rotZ,rotY);
        mesh.scale.set(scaleX,scaleY,scaleZ);
    }

    const animate = () => {

    if(_frameCount >= objectData.objectsTranforms.length || _frameCount < 0)
    return false;

    mesh.visible = objectData?.objectsTranforms[_frameCount]?.isEnabled;
    

    if(_frameCount >= 0)
    {
      if(objectData.isReverseAnimation && _frameCount === 0)
      {
        _newPos = _startPos.clone();
        _newRot = _startRot.clone();
        _newScale = _startScale.clone();
      }
       else
      {
        _newPos = objectData?.objectsTranforms[_frameCount]?.objectPostion;        
        _newRot = objectData?.objectsTranforms[_frameCount]?.objectRotation;
        _newScale = objectData?.objectsTranforms[_frameCount]?.objectScale;
      }
    }
    
    // console.log("Animation Happening! currently at ",_frameCount, " frame of total ", objectData.objectsTranforms.length - 1, "in the meshName of ",mesh.name);
    if(mesh.userData.tempData.moveTween != undefined) mesh.userData.tempData.moveTween.stop();
     if(!mesh.position.equals(_newPos))
     {
         mesh.userData.tempData.moveTween = new TWEEN.Tween(mesh.position).to(_newPos,time);
         mesh.userData.tempData.moveTween.start();
     }

     if(mesh.userData.tempData.rotateTween != undefined) mesh.userData.tempData.rotateTween.stop();
     if(!objectData?.objectsTranforms[_frameCount]?.isXSpin && 
        !objectData?.objectsTranforms[_frameCount]?.isZSpin &&
         !objectData?.objectsTranforms[_frameCount]?.isYSpin)
        {
          const vector = new THREE.Vector3().setFromEuler(_newRot);
          mesh.userData.tempData.rotateTween = new TWEEN.Tween(mesh.rotation).to(vector,time);
          mesh.userData.tempData.rotateTween.start();

          /* var targetRotationX = _newRot.x;
           var targetRotationY = _newRot.y;
           var targetRotationZ = _newRot.z;
          
           mesh.userData.tempData.rotateTween = new TWEEN.Tween(mesh.rotation).to({ x: targetRotationX, y: targetRotationY, z: targetRotationZ }, time).start(); 

           var targetQuaternion = new THREE.Quaternion().setFromEuler(new THREE.Euler(_newRot.x, _newRot.y, _newRot.z));
         mesh.userData.tempData.rotateTween = new TWEEN.Tween(mesh.quaternion)
         .to({ x: targetQuaternion.x, y: targetQuaternion.y, z: targetQuaternion.z, w: targetQuaternion.w }, time).start();
*/
        }

         const startScale = mesh.scale;     
         mesh.userData.tempData.scaleTween  = new TWEEN.Tween(startScale).to(_newScale, time).onUpdate(() => {
         // Update the scale of the object within the tween animation
           mesh.scale.copy(startScale);
         }).onComplete(() => {
            if(objectData.isReverseAnimation){
                _frameCount--;
            }
            else{
            _frameCount++;}
            animate();
            DoSpin();
         });

         mesh.userData.tempData.scaleTween.start();
    }


    const DoSpin = () => {    
     if (_frameCount >= objectData.objectsTranforms.length || _frameCount < 0)
        return false;

        if(mesh.userData.tempData.spinTween != undefined){
            mesh.userData.tempData.spinTween.stop();
        }


        let revsere = 1;

       if(objectData?.objectsTranforms[_frameCount]?.isReverse){
        revsere *= -1;
       }
    
        if (objectData?.objectsTranforms[_frameCount]?.isXSpin) {
            mesh.userData.tempData.spinTween= new TWEEN.Tween(mesh.rotation).to({ x: mesh.rotation.x + (Math.PI * 2 *revsere) }, 2000).repeat(Infinity).start(); 
        }
        if (objectData?.objectsTranforms[_frameCount]?.isYSpin) {
            mesh.userData.tempData.spinTween = new TWEEN.Tween(mesh.rotation).to({ y: mesh.rotation.y - (Math.PI * 2*revsere) }, 2000).repeat(Infinity).start(); 
        }
        if (objectData?.objectsTranforms[_frameCount]?.isZSpin) { 
            mesh.userData.tempData.spinTween = new TWEEN.Tween(mesh.rotation).to({ z: mesh.rotation.z + (Math.PI * 2*revsere) }, 2000).repeat(Infinity).start(); 
        }
    }
    
animate();
DoSpin();
}

export const callingFunction = (functionName, mesh,...args) => {
  
    switch(functionName){
      case 'PlayAnim':
       // if(args[0] < 0)
      //  return;

      const currentStepData = mesh.userData.objectDatum[args[0]];

      if(currentStepData == undefined)
       return;

      let {x:posX,y:posY,z:posZ} = currentStepData.objectPostion;
      const { _x: rotX, _y: rotY, _z: rotZ } = currentStepData.objectRotation;


     // if(currentStepData.isAnimatonOn)
      {
        mesh?.userData?.tempData?.rotateTween?.stop();
        mesh?.userData?.tempData?.moveTween?.stop();
        
       mesh.position.set(posX, posY, posZ);
       mesh.rotation.set(rotX, rotY, rotZ, "XYZ"); 

      
  
      TweenAnim(mesh,currentStepData);
      }
    break;
      
    case 'SetUpObject':
      // Check if the temporary data exists in the userData
      mesh.userData.tempData = mesh.userData.tempData || {};

        // Check if the temporary data exists in the userData
        mesh.userData.tempData.moveTween = undefined; mesh.userData.tempData.rotateTween = undefined;
        mesh.userData.tempData.scaleTween = undefined; mesh.userData.tempData.spinTween = undefined;

        mesh.visible = mesh?.userData?.objectDatum[0]?.objectsTranforms[1]?.isEnabled;    
        mesh.position.copy(mesh?.userData?.objectDatum[0]?.objectsTranforms[1]?.objectPostion);
        mesh.rotation.copy(mesh?.userData?.objectDatum[0]?.objectsTranforms[1]?.objectRotation);
        mesh.scale.copy(mesh?.userData?.objectDatum[0]?.objectsTranforms[1]?.objectScale);  


				const labelDiv = document.createElement( 'div' );
				labelDiv.className = 'label';
				labelDiv.textContent = mesh.name;
				labelDiv.style.backgroundColor = 'transparent';

				// const meshLabel = new CSS2DObject(labelDiv);
				// meshLabel.position.set( 1, 0, 1 );
				// meshLabel.center.set( 0, 1 );
				// mesh.add(meshLabel);
        // meshLabel.visible = false;
        // mesh.userData.tempData.label = meshLabel;
    break;

    }
}
